import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller';

import { NHAGridCellRabbitEarComponent } from './components/grid-cell-rabbit-ear/grid-cell-rabbit-ear.component';
import { GridHeaderSortableComponent } from './components/grid-header-sortable/grid-header-sortable.component';
import { NHAGridComponent } from './grid.component';
import { NHAGridEvalSizePipe } from './pipes/eval-size.pipe';
import { NHAGridEvalRowsPipe } from './pipes/eval-rows.pipe';
import { NHAPipesModule } from '@nha/pipes';
import { NHAGridHtmlIsFuncPipe } from './pipes/html-is-func.pipe';
import { NHAGridShowGroupRowPipe } from './pipes/show-group-row.pipe';
import { GridSortArrowComponent } from './components/grid-sort-arrow/grid-sort-arrow.component';

export const GRID_COMPONENTS = [NHAGridComponent, NHAGridCellRabbitEarComponent, GridHeaderSortableComponent, GridSortArrowComponent];
export const GRID_PIPES = [NHAGridEvalSizePipe, NHAGridEvalRowsPipe, NHAGridHtmlIsFuncPipe, NHAGridShowGroupRowPipe];

@NgModule({
	imports: [CommonModule, VirtualScrollerModule, NHAPipesModule, GRID_COMPONENTS, GRID_PIPES],
	exports: [GRID_COMPONENTS, GRID_PIPES]
})
export class NHAGridV3Module {}
